module.exports = __webpack_public_path__ + "img/Rhonda_Morris@1x.b3ced79a.png";